import { Injectable } from '@angular/core';
import { BackendApiService } from '@shared/core';
import { PPA_ADD } from '../actions/index';
import { PpaAddSubmitFailureAction, PpaAddSubmitSuccessAction } from '../actions/ppa-add-actions';
import { Action } from '../action';
import { getContractDataSubscriptionSpaqContractNo, getPpaAddForm } from '../selectors';
import { PaymentPPAInfo } from '@shared/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class PpaEffects {
	@Effect({ dispatch: true })
	submit$: Observable<Action> = this.actions$.pipe(
		ofType(PPA_ADD.SUBMIT),
		withLatestFrom(this.store.pipe(select(getPpaAddForm)), this.store.pipe(select(getContractDataSubscriptionSpaqContractNo))),
		switchMap(([_a, ppa, contractNo]: [unknown, PaymentPPAInfo, unknown]) => {
			return this.backendApi
				.addPpa({
					...ppa,
					financialInstitutionId: ppa.financialInstitutionId,
					contractNo
				})
				.pipe(
					map(() => new PpaAddSubmitSuccessAction()),
					catchError(e => of(new PpaAddSubmitFailureAction(e)))
				);
		})
	);

	constructor(
		private actions$: Actions,
		private store: Store<any>,
		private backendApi: BackendApiService
	) {}
}
